import {
  Popover,
  PopoverTrigger,
  Button,
  PopoverContent,
  PopoverBody,
  Icon,
  useDisclosure,
  useOutsideClick,
  Box,
} from '@chakra-ui/react';
import { useEffect, useRef, useState } from 'react';
import BlueprintIcon from '@/assets/icons/blueprint/Blueprint';
import { FilterItem } from './FilterItem';
import { KText } from '@/ui-library/components/text';
import { ChevronDown } from '@kula-ai/icons-core';

const filters = [
  { label: 'All Blueprints', value: 'all' },
  { label: 'Kula Blueprints', value: 'kula' },
  { label: 'Org. Blueprints', value: 'org' },
];

export const BluprintTypeFilter = ({ onSelect = () => {}, filter = {} }) => {
  const defaultSelected = filters[0];
  const [selected, setSelected] = useState(defaultSelected);
  const ref = useRef(null);
  const { isOpen, onToggle, onClose } = useDisclosure();

  useEffect(() => {
    if (filter?.type === null) {
      setSelected(defaultSelected);
    }
  }, [filter]); //eslint-disable-line react-hooks/exhaustive-deps

  useOutsideClick({
    ref: ref,
    handler: () => onClose(),
  });

  return (
    <Box as="span" ref={ref}>
      <Popover placement="bottom-start" isOpen={isOpen}>
        <PopoverTrigger>
          <Button
            data-test-id="blueprint-type"
            px="6px"
            height="2rem"
            variant="quaternary"
            bg="primary-50"
            textDecoration="none"
            onClick={onToggle}
            borderRadius="6px"
            borderColor="transparent"
            _hover={{ textDecoration: 'none' }}
            _focus={{ textDecoration: 'none' }}
            leftIcon={
              <Icon
                as={BlueprintIcon}
                width="16px"
                height="16px"
                color="secondary-700"
              />
            }
          >
            <KText size="sm-medium" color="secondary-700">
              {selected?.label}
            </KText>
            <Icon
              transitionDuration=".5s"
              willChange="transform"
              transform={isOpen ? 'rotateX(180deg)' : 'rotateX(0)'}
              as={ChevronDown}
              width="16px"
              height="16px"
              color="secondary-700"
            />
          </Button>
        </PopoverTrigger>
        <PopoverContent
          minH="100px"
          w="200px"
          boxShadow="0px 4px 12px 6px rgb(46 47 48 / 6%)"
        >
          <PopoverBody display="flex" flexDir="column" p="0">
            {filters?.map((filter, idx) => {
              return (
                <FilterItem
                  key={idx}
                  onSelect={(item) => {
                    onSelect(item);
                    setSelected(item);
                    onClose();
                  }}
                  item={filter}
                >
                  <KText>{filter?.label}</KText>
                </FilterItem>
              );
            })}
          </PopoverBody>
        </PopoverContent>
      </Popover>
    </Box>
  );
};
